import { render, staticRenderFns } from "./UnsubscribeAction.vue?vue&type=template&id=41b0047a"
import script from "./UnsubscribeAction.vue?vue&type=script&lang=js"
export * from "./UnsubscribeAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports